<template>
  <div class="no-metamask-container text-center">
    <a href="https://www.zoombies.info/">
      <img
        class="zoombie-logo"
        alt="Zoombies World Logo"
        src="./assets/zoombies_logo_horizontal_white_text_only.png"
      />
    </a>

    <h3 class="text-drop-shadow">
      Metamask or a compatible blockchain wallet is required to access this
      website.
    </h3><br/>
    <h2 class="mobile-no-metamask">  
      <a href="https://metamask.app.link/dapp/zoombies.world/moonbeam"
        ><b-button variant="primary">Open site in the Metamask mobile app</b-button></a
      ><br/><br/>
    </h2>

    <h2>
      <a href="https://metamask.io/">
        <b-button variant="primary">Install metamask</b-button></a>
    </h2>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
export default {
  name: "NoMetaMask",
  components : {
    BButton,
  },
};
</script>

<style scoped lang="scss">
.mobile-no-metamask {
  display: none;
}

.zoombie-logo {
  width: 200px;
  margin-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;

  &:hover {
    transform: scale(1.1);
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .mobile-no-metamask {
    display: block;
  }
}

.text-drop-shadow {
  text-shadow: 2px 2px 2px #000000;
}
</style>
